module.exports = __webpack_public_path__ + "static/media/M1-34-Wyn-Arsalis-cod153.5eb980b0.png";